import React, { memo, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardData } from "../../../store/dashboard/action";
import { sortCategoriesByOrder } from "../../../hooks/utilsFn/utilsFn";


const ProductFilterMobile = memo(({ categorySlugs = [], setSearchParams }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state?.Dashboard?.categories);
  const categoryRefs = useRef({});

  useEffect(() => {
    if (!categories?.length) {
      dispatch(fetchDashboardData());
    }
  }, [categories, dispatch]);

  const handleToggle = (slug) => {
    const selectedSlug = String(slug);
    const isAlreadySelected = categorySlugs.includes(selectedSlug);

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      if (isAlreadySelected) {
        params.delete("categorySlug");
      } else {
        params.set("categorySlug", selectedSlug);
      }

      return params;
    });
  };

  useEffect(() => {
    if (!categorySlugs?.length) return;
    const selectedSlug = categorySlugs[0];
    const selectedElement = categoryRefs.current[selectedSlug];
    if (selectedElement) {
      selectedElement.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [categorySlugs]);


  const category = sortCategoriesByOrder(categories);

  return (
    <Box sx={{ width: "100%", borderRadius: "12px", overflow: "hidden" }}>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          py: 1,
          overflowX: "auto",
          overflowY: "hidden",
          flexWrap: "nowrap",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {category?.map((category) => {
          const isSelected = categorySlugs?.includes(String(category?.slug));
          return (
            <Box
              key={category?.id}
              ref={(el) => {
                categoryRefs.current[String(category?.slug)] = el;
              }}
              onClick={() => handleToggle(category?.slug)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                maxWidth: "calc(50% - 4px)",
                width: "fit-content",
                px: 1.5,
                py: 1,
                borderRadius: "12px",
                border: "1px solid #E4C18F",
                backgroundColor: isSelected ? "#E4C18F" : "#fff",
                cursor: "pointer",
                transition: "background-color .2s ease",
              }}
            >
              <Box
                component="img"
                src={category?.logo}
                alt={category?.name}
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Be Vietnam Pro",
                  color: isSelected ? "primary.main" : "#000",
                  textTransform: "capitalize",
                }}
              >
                {category?.name}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
});

export default ProductFilterMobile;